import JSONToCSVConvertor from './json-to-csv';
import StringToCSV from './string-to-csv'

 export default angular.module('accessApp.MiscServices', [])
  .factory('JSONToCSVConvertor', JSONToCSVConvertor)
  .factory('StringToCSV', StringToCSV)
  .name;


// WEBPACK FOOTER //
// ./client/components/services/index.js